import { render, staticRenderFns } from "./Utenti.vue?vue&type=template&id=440d274f&"
import script from "./Utenti.vue?vue&type=script&lang=ts&"
export * from "./Utenti.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports